import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import {
  fetchMultiMarketEventData,
  getSecondaryMarketsByEvent,
  getSecondaryMatchOddsByEvent,
  getBookmakerMarketsByEvent,
  fetchOpenBets,
  getFancyMarketsByEvent,
  getHouseIdFromToken,
  getParentIdFromToken,
  getAccountIdFromToken,
} from '../../store';
import './ExchangeAllMarkets.scss';
import ExchMultiMarket from './ExchangeMultiMarket';
import { UserBet } from '../../models/UserBet';
import { useMarketLocalState } from '../../hooks/storageHook';
import API_V2 from '../../api-services/svls-api';
import {
  subscribeWsForNotifications,
  subscribeWsForNotificationsPerAdmin,
  unsubscribePNWsforEvents,
} from '../../webSocket/webSocket';

type StoreProps = {
  fetchOpenBets: (eventId: string[] | string, sportId?: string) => void;
  fetchMultiMarketEventData: () => void;
  marketData: any;
  secondaryMultiMatchOdds: any;
  secondaryMultiMarket: any;
  seMultiEventData: any;
  openBets: UserBet[];
  loggedIn: boolean;
  triggerFetchMarkets: number;
  triggerFetchOrders: number;
  houseId: string;
  parentId: string;
  accountId: string;
  pushNotifWSConnection: boolean;
};

const MultiMarketView: React.FC<StoreProps> = (props) => {
  const {
    fetchMultiMarketEventData,
    marketData,
    secondaryMultiMatchOdds,
    secondaryMultiMarket,
    seMultiEventData,
    loggedIn,
    openBets,
    fetchOpenBets,
    triggerFetchMarkets,
    triggerFetchOrders,
    houseId,
    parentId,
    accountId,
    pushNotifWSConnection
  } = props;

  const [exposureMap, setExposureMap] = useState(null);
  const [enableFetchOrders, setEnableFetchOrders] = useState<boolean>(false);

  useEffect(() => {
    fetchMultiMarketEventData();
  }, [triggerFetchMarkets]);

  const [multiMarketData] = useMarketLocalState();

  useEffect(() => {
    if (multiMarketData?.length) {
      let eventIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
      });
      fetchOpenBets(eventIds);
      fetchOpenBetsRisk();
    }
    setEnableFetchOrders(true);
  }, [multiMarketData]);

  useEffect(() => {
    if (loggedIn && enableFetchOrders && multiMarketData?.length) {
      let eventIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
      });
      setTimeout(() => {
        fetchOpenBets(eventIds);
        fetchOpenBetsRisk();
      }, 1000);
    }
  }, [loggedIn, triggerFetchOrders]);

  useEffect(() => {
    if (loggedIn) {
      unsubscribePNWsforEvents(houseId);
      unsubscribePNWsforEvents(parentId);
      subscribeWsForNotificationsPerAdmin(true, houseId, parentId, accountId);
      subscribeWsForNotifications(true, houseId);
    }
    return () => {
      unsubscribePNWsforEvents(houseId);
      unsubscribePNWsforEvents(parentId);
      if (!window.location.pathname.includes('multi-market')) {
        subscribeWsForNotificationsPerAdmin(
          false,
          houseId,
          parentId,
          accountId
        );
        subscribeWsForNotifications(false, houseId);
      }
    };
  }, [pushNotifWSConnection, loggedIn]);

  const fetchOpenBetsRisk = async () => {
    try {
      if (!multiMarketData?.length) {
        return;
      }

      let eventIds = [];
      let marketIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
        marketIds.push(item?.marketId);
      });

      const response = await API_V2.get(
        '/reports/v2/risk-management/user-risk',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            eventId: Array.isArray(eventIds) ? eventIds.join(',') : eventIds,
            marketId: Array.isArray(marketIds)
              ? marketIds.join(',')
              : marketIds,
          },
        }
      );
      setExposureMap(response.data.marketExposureMap);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    document.getElementsByClassName('router-ctn')[0].scrollIntoView();
  }, []);
  return (
    <div className="eam-ctn">
      <div className="carw">
        <div className="arrow arrow-right">
          <div className="event-name">MultiMarket</div>
        </div>
      </div>{' '}
      {multiMarketData?.length &&
      marketData &&
      Object.keys(marketData)?.length ? (
        Object.keys(marketData).map((item) => {
          return (
            <ExchMultiMarket
              key={item}
              loggedIn={loggedIn}
              eventData={marketData[item] ?? {}}
              openBets={openBets}
              secondaryMarkets={getSecondaryMarketsByEvent(
                secondaryMultiMarket,
                item
              )}
              secondaryMatchOdds={getSecondaryMatchOddsByEvent(
                secondaryMultiMatchOdds,
                item
              )}
              bmMData={getBookmakerMarketsByEvent(secondaryMultiMarket, item)}
              eventId={marketData[item]?.eventId}
              isMultiMarket={true}
              fmData={getFancyMarketsByEvent(secondaryMultiMarket, item)}
              exposureMap={exposureMap ? exposureMap : null}
            />
          );
        })
      ) : (
        <div className="no-data">
          There are currently no followed multi markets.
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    openBets: state.exchBetslip.openBets,
    loggedIn: state.auth.loggedIn,
    marketData: state.multiMarket.multiMarketData,
    secondaryMultiMarket: state.multiMarket.secondaryMultiMarketsMap,
    secondaryMultiMatchOdds: state.multiMarket.secondaryMultiMatchOddsMap,
    seMultiEventData: state.multiMarket.premiumMultiMarketsMap,
    triggerFetchMarkets: state.multiMarket.triggerFetchMarkets,
    triggerFetchOrders: state.multiMarket.triggerFetchOrders,
    houseId: getHouseIdFromToken(),
    parentId: getParentIdFromToken(),
    accountId: getAccountIdFromToken(),
    pushNotifWSConnection: state.exchangeSports.pushNotifWSConnection,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchMultiMarketEventData: () => dispatch(fetchMultiMarketEventData()),
    fetchOpenBets: (eventId: string[] | string, sportId?: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiMarketView);
